import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Skeleton from "react-loading-skeleton";
import 'react-loading-skeleton/dist/skeleton.css';
import { FaTools, FaTruckMoving, FaHardHat } from "react-icons/fa";
import Logo from "../assets/logo.png";
import BgImage from "../assets/hero-bg.jpg";

const Index = () => {
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoading(false), 1200);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className="relative min-h-screen flex flex-col bg-cover bg-center"
      style={{ backgroundImage: `url(${BgImage})` }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/50 dark:bg-black/60 z-0"></div>

      {/* Header */}
      <header className="relative z-10 flex items-center justify-between px-6 py-4 bg-gradient-to-r from-emerald-700 via-emerald-600 to-emerald-500/90 text-white shadow-md">
        {isLoading ? (
          <Skeleton height={48} width={100} baseColor="#1e3a34" highlightColor="#34d399" />
        ) : (
          <img src={Logo} alt="Logo" className="h-12" />
        )}
        <p className="text-lg font-semibold">infraconsoft.net</p>
      </header>

      {/* Main Section */}
      <main className="relative z-10 flex flex-col-reverse lg:flex-row items-center justify-between px-6 lg:px-20 py-10 gap-10 flex-grow text-white">
        {/* Text */}
        <motion.div
          initial={{ opacity: 0, x: -50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className="max-w-xl"
        >
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold mb-4 drop-shadow-lg">
            Transforming Construction with Innovation
          </h1>
          <motion.p
            className="text-base sm:text-lg mb-6 text-gray-200"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4, duration: 0.6 }}
          >
            Embrace a new era of construction with our groundbreaking software
            solutions. From project management to real-time analytics, we
            streamline complex processes into intuitive workflows for every team.
          </motion.p>

          <motion.div whileHover={{ scale: 1.05 }}>
            <Link
              to="/login"
              className="inline-block px-6 py-3 bg-white text-emerald-700 font-semibold text-lg rounded-xl shadow-lg hover:bg-gray-100 transition"
            >
              Click here to login
            </Link>
          </motion.div>
        </motion.div>

        {/* Image & Icons */}
        <motion.div
          initial={{ opacity: 0, x: 50 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ duration: 1 }}
          className="flex flex-col items-center"
        >
          {isLoading ? (
            <Skeleton height={300} width={300} baseColor="#1e3a34" highlightColor="#34d399" />
          ) : (
            <motion.img
              src={Logo}
              alt="Visual"
              className="w-full max-w-md rounded-xl shadow-xl"
              initial={{ scale: 0.8 }}
              animate={{ scale: 1 }}
              transition={{ duration: 0.6 }}
            />
          )}

          <motion.div
            className="flex gap-6 mt-6 text-emerald-300 text-3xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.8, duration: 0.6 }}
          >
            <div className="flex flex-col items-center">
              <FaTools />
              <span className="text-sm mt-1 text-gray-200">Inventory</span>
            </div>
            <div className="flex flex-col items-center">
              <FaTruckMoving />
              <span className="text-sm mt-1 text-gray-200">Vehicles</span>
            </div>
            <div className="flex flex-col items-center">
              <FaHardHat />
              <span className="text-sm mt-1 text-gray-200">Payroll</span>
            </div>
          </motion.div>
        </motion.div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 text-center py-4 text-sm text-gray-300 bg-black/40 backdrop-blur-sm">
        &copy; {new Date().getFullYear()} Infraconsoft. All rights reserved.
      </footer>
    </div>
  );
};

export default Index;
